import React from 'react';
import { usePortalLanguage } from '../../../contexts/PortalLanguageContext';

const digits = (phone) => (phone || '').replace(/[^0-9+]/g, '');

function PartyRow({ role, contact }) {
    const { t } = usePortalLanguage();
    if (!contact) return null;
    const linkClass = 'inline-flex min-h-[44px] items-center font-semibold text-[color:var(--sidebar-text-color)] underline decoration-[color:var(--color-accent)] decoration-2 underline-offset-4 hover:bg-[color:var(--sidebar-item-hover)] rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[color:var(--color-accent)]';
    return (
        <div>
            <div className="text-xs font-semibold uppercase tracking-[0.14em] text-[color:var(--sidebar-text-color)] opacity-90">{role}</div>
            <div className="mt-1 font-semibold text-[color:var(--sidebar-text-color)]">{contact.name || t('Not provided')}</div>
            <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-0 text-sm text-[color:var(--sidebar-text-color)]">
                {contact.phone && (
                    <>
                        <a href={`tel:${digits(contact.phone)}`} className={linkClass}>{contact.phone}</a>
                        <a href={`sms:${digits(contact.phone)}`} className={linkClass}>{t('Text')}</a>
                    </>
                )}
                {contact.email && <a href={`mailto:${contact.email}`} className={`${linkClass} break-all`}>{contact.email}</a>}
            </div>
        </div>
    );
}

function PortalTeamCard({ teamContacts, isCompactLayout }) {
    const { t } = usePortalLanguage();
    const titleCompany = teamContacts?.titleCompany || null;
    const lender = teamContacts?.lender || null;
    if (!titleCompany && !lender) return null;

    return (
        <div
            data-testid="portal-team-card"
            style={{ backgroundImage: 'var(--gradient-sidebar)' }}
            className={`rounded-2xl border border-[color:var(--sidebar-border-color)] text-[color:var(--sidebar-text-color)] shadow-md ${isCompactLayout ? 'p-5' : 'p-6'}`}
        >
            <h2 className="text-lg font-semibold text-[color:var(--sidebar-text-color)]">{t('Your transaction team')}</h2>
            <p className="mt-1 text-sm text-[color:var(--sidebar-text-color)]">{t('The other professionals working on your transaction.')}</p>
            <div className="mt-4 space-y-4">
                <PartyRow role={t('Title Company')} contact={titleCompany} />
                <PartyRow role={t('Lender')} contact={lender} />
            </div>
        </div>
    );
}

export default PortalTeamCard;
